import React from "react";
import {Route, Switch} from "react-router-dom";
// import AppliedRoute from "./components/AppliedRoute";
import asyncComponent from "./components/AsyncComponent";
import AuthenticatedRoute from "./components/AuthenticatedRoute";
import UnauthenticatedRoute from "./components/UnauthenticatedRoute";
import PasswordRoute from "./components/PasswordRoute";

const AsyncHome = asyncComponent(() => import("./containers/Home"));
const AsyncDesign = asyncComponent(() => import("./containers/Design"));
const AsyncCV = asyncComponent(() => import("./containers/CV"));
const AsyncProjects = asyncComponent(() => import("./containers/Projects"));
const AsyncAbout = asyncComponent(() => import("./containers/About"));
const Async3DPrint = asyncComponent(() => import("./containers/3DPrint"));
const AsyncContact = asyncComponent(() => import("./containers/Contact"));
const AsyncSmartie = asyncComponent(() => import("./containers/Smartie"));
const AsyncKirkeneskonferansen = asyncComponent(() => import("./containers/Kirkeneskonferansen"));
const AsyncKirkeneskonferansenQuestions = asyncComponent(() => import("./containers/KirkeneskonferansenQuestions"));
const AsyncBarelLuxus = asyncComponent(() => import("./containers/BarelLuxus"));
const AsyncBarelLuxusReport = asyncComponent(() => import("./containers/BarelLuxusReport"));
const AsyncBarelDatasheet = asyncComponent(() => import("./containers/BarelDatasheet"));
const AsyncBarelBeacon = asyncComponent(() => import("./containers/BarelBeacon"));
const AsyncIntern = asyncComponent(() => import("./containers/Intern"));
const AsyncLogin = asyncComponent(() => import("./containers/Login"));
const AsyncSignup = asyncComponent(() => import("./containers/Signup"));
const AsyncTimeRegistration = asyncComponent(() => import("./containers/TimeRegistration"));
const AsyncNewTime = asyncComponent(() => import("./containers/NewTime"));
const AsyncTimeOverview = asyncComponent(() => import("./containers/TimeOverview"));
const AsyncRedirectOverview = asyncComponent(() => import("./containers/RedirectOverview"));
const AsyncRedirect = asyncComponent(() => import("./containers/Redirect"));
const AsyncJaktaOverview = asyncComponent(() => import("./containers/JaktaOverview"));
const AsyncJaktaTivoliWindow = asyncComponent(() => import("./containers/JaktaTivoliWindow"));
const AsyncJaktaResult = asyncComponent(() => import("./containers/JaktaResult"));
const AsyncNotFound = asyncComponent(() => import("./containers/NotFound"));

export default ({childProps}) =>
    <Switch>
        <Route path="/" exact component={AsyncHome}/>
        <Route path="/design" exact component={AsyncDesign}/>
        <PasswordRoute path="/cv" exact component={AsyncCV} pw={"cv"}/>
        <Route path="/prosjekter" exact component={AsyncProjects}/>
        <Route path="/selskapet" exact component={AsyncAbout}/>
        <Route path="/3d-kart" exact component={Async3DPrint}/>
        <Route path="/oss" exact component={AsyncContact}/>
        <Route path="/smartie" exact component={AsyncSmartie}/>
        <Route path="/kirkeneskonferansen" exact component={AsyncKirkeneskonferansen}/>
        {/*<PasswordRoute path="/kkquestions" exact component={AsyncKirkeneskonferansenQuestions} pw={"kkonf2018"}/>*/}
        <Route path="/kkquestions" exact component={AsyncKirkeneskonferansenQuestions} pw={"kkonf2018"}/>
        <PasswordRoute path="/barel" exact component={AsyncBarelLuxus} pw={"luxus"}/>
        <Route path="/barel/:id" exact component={AsyncBarelLuxusReport}/>
        <Route path="/barel-datasheet/:id" exact component={AsyncBarelDatasheet}/>
        <Route path="/smartlight" exact component={AsyncBarelBeacon}/>
        <Route path="/jakta-tivoli" exact component={AsyncJaktaTivoliWindow}/>
        <AuthenticatedRoute path="/intern" exact component={AsyncIntern} props={childProps}/>
        <AuthenticatedRoute path="/intern/time" exact component={AsyncTimeRegistration} props={childProps}/>
        <AuthenticatedRoute path="/intern/time/new" exact component={AsyncNewTime} props={childProps}/>
        <AuthenticatedRoute path="/intern/time/overview" exact component={AsyncTimeOverview} props={childProps}/>
        <AuthenticatedRoute path="/intern/redirect/overview" exact component={AsyncRedirectOverview} props={childProps}/>
        <AuthenticatedRoute path="/intern/jakta/overview" exact component={AsyncJaktaOverview} props={childProps}/>
        <AuthenticatedRoute path="/intern/jakta/result" exact component={AsyncJaktaResult} props={childProps}/>
        <Route path="/r/:projectId" exact component={AsyncRedirect}/>
        <Route path="/redirect/:projectId" exact component={AsyncRedirect}/>
        <UnauthenticatedRoute path="/intern/login" exact component={AsyncLogin} props={childProps}/>
        <UnauthenticatedRoute path="/intern/signup" exact component={AsyncSignup} props={childProps}/>
        {/* Finally, catch all unmatched routes */}
        <Route component={AsyncNotFound}/>
    </Switch>;


// WEBPACK FOOTER //
// ./src/Routes.js